export const ru: Record<string, string> = {
  'app.title': 'Бутылочка',

  'common.ok': 'ОК',
  'common.cancel': 'Отмена',
  'common.close': 'Закрыть',
  'common.back': 'Назад',
  'common.retry': 'Повторить',
  'common.save': 'Сохранить',
  'common.send': 'Отправить',
  'common.loading': 'Загрузка…',
  'common.reconnecting': 'Связь потеряна. Переподключаемся…',
  'common.offline': 'Нет подключения к интернету',
  'common.hearts': '❤ {count}',
  'common.optional': 'необязательно',

  'errors.BAD_REQUEST': 'Некорректный запрос.',
  'errors.VALIDATION_FAILED': 'Проверьте введённые данные.',
  'errors.UNAUTHORIZED': 'Откройте игру заново из Telegram.',
  'errors.TOKEN_EXPIRED': 'Сессия истекла. Переподключаемся…',
  'errors.FORBIDDEN': 'Это действие недоступно.',
  'errors.NOT_FOUND': 'Не найдено.',
  'errors.CONFLICT': 'Данные изменились. Попробуйте ещё раз.',
  'errors.UNPROCESSABLE': 'Сейчас это действие невозможно.',
  'errors.RATE_LIMITED': 'Слишком быстро! Подождите немного.',
  'errors.PAYLOAD_TOO_LARGE': 'Слишком длинно.',
  'errors.UNIQUE_VIOLATION': 'Такое уже существует.',
  'errors.INTERNAL_ERROR': 'Что-то пошло не так. Попробуйте ещё раз.',
  'errors.SERVICE_UNAVAILABLE': 'Игра перезапускается. Скоро вернёмся.',
  'errors.INIT_DATA_INVALID': 'Откройте игру через Telegram-бота.',
  'errors.INIT_DATA_EXPIRED': 'Ссылка запуска устарела. Откройте игру из бота заново.',
  'errors.BANNED': 'Ваш аккаунт заблокирован.',
  'errors.ONBOARDING_REQUIRED': 'Сначала заполните профиль.',
  'errors.SESSION_REPLACED': 'Игра открыта на другом устройстве.',
  'errors.LOGIN_FAILED': 'Неверный логин или пароль.',
  'errors.WRONG_PASSWORD': 'Текущий пароль неверный.',
  'errors.ROOM_NOT_FOUND': 'Этого стола больше нет.',
  'errors.ROOM_FULL': 'За столом нет мест.',
  'errors.ROOM_BUSY': 'Стол занят. Попробуйте ещё раз.',
  'errors.NOT_IN_ROOM': 'Вы не за столом.',
  'errors.NOT_YOUR_TURN': 'Сейчас не ваш ход.',
  'errors.NOT_IN_ROUND': 'Вы не участвуете в этом раунде.',
  'errors.STALE_TURN': 'Уже поздно.',
  'errors.ALREADY_DECIDED': 'Вы уже сделали выбор.',
  'errors.MUTED': 'Сейчас вы не можете писать в чат.',
  'errors.BLOCKED': 'Вы не можете взаимодействовать с этим игроком.',
  'errors.MESSAGE_REJECTED': 'Это сообщение нельзя отправить. Ссылки и оскорбления запрещены.',
  'errors.CANNOT_TARGET_SELF': 'Нельзя сделать это с собой.',
  'errors.INSUFFICIENT_FUNDS': 'Недостаточно сердечек.',
  'errors.INSUFFICIENT_GM': 'Недостаточно GM.',
  'errors.TRANSFER_LIMIT': 'На сегодня отправлено достаточно. Попробуйте завтра.',
  'errors.NOT_FRIENDS': 'Отправлять можно только друзьям.',
  'errors.ALREADY_CLAIMED': 'Сегодня уже получено. Возвращайтесь завтра!',
  'errors.GIFT_NOT_FOUND': 'Этот подарок недоступен.',
  'errors.VIDEO_UNAVAILABLE': 'Это видео нельзя воспроизвести в игре. Попробуйте другую ссылку.',
  'errors.NO_CHANCES': 'У вас не осталось шансов.',
  'errors.NO_BOOSTER': 'У вас нет этого бустера.',
  'errors.PRODUCT_NOT_FOUND': 'Этот набор недоступен.',

  'gender.MALE': 'Мужчина',
  'gender.FEMALE': 'Женщина',
  'locale.en': 'English',
  'locale.ru': 'Русский',
  'locale.uz': 'Oʻzbekcha',
  'locale.az': 'Azərbaycanca',
  'locale.tr': 'Türkçe',

  'onboarding.title': 'Добро пожаловать в «Бутылочку»!',
  'onboarding.subtitle': 'Крутите бутылочку, целуйтесь, дарите подарки и знакомьтесь.',
  'onboarding.language': 'Язык',
  'onboarding.name': 'Имя за столом',
  'onboarding.gender': 'Я',
  'onboarding.birth_year': 'Год рождения',
  'onboarding.birth_year_hint': 'Показывается как возраст рядом с именем',
  'onboarding.rules_title': 'Правила стола',
  'onboarding.rule_respect': 'Будьте вежливы. Оскорбления, спам и ссылки запрещены.',
  'onboarding.rule_virtual': 'Поцелуи и подарки виртуальные — просто для веселья.',
  'onboarding.rule_block': 'Любого игрока можно заблокировать или пожаловаться на него.',
  'onboarding.adult': 'Мне есть 18 лет, и я принимаю правила стола',
  'onboarding.start': 'Играть',
  'onboarding.underage': 'Извините, игра только для игроков от 18 лет.',

  'lobby.play': 'ИГРАТЬ',
  'lobby.balance': 'Ваши сердечки',
  'lobby.ratings': 'Рейтинги',
  'lobby.achievements': 'Достижения',
  'lobby.shop': 'Купить сердечки',
  'lobby.settings': 'Настройки',
  'lobby.invite': 'Пригласить друзей',
  'lobby.profile': 'Профиль',

  'table.title': 'Стол {code}',
  'table.waiting_players': 'Ждём других игроков…',
  'table.waiting_turn': 'Ожидайте следующего хода',
  'table.your_turn': 'Крутите бутылочку!',
  'table.tap_bottle': 'Нажмите на бутылочку',
  'table.spins': 'Крутит бутылочку',
  'table.your_choice': 'Ваш выбор',
  'table.kiss_back': 'Поцелует в ответ?',
  'table.will_they': 'Поцелуются или нет?',
  'table.kiss': 'Поцеловать',
  'table.refuse': 'Отказать',
  'table.result_mutual': 'Взаимный поцелуй! 💋',
  'table.result_one': '{from} поцеловал(а) {to} 💋',
  'table.result_none': 'В этот раз без поцелуя',
  'table.change': 'Сменить стол',
  'table.leave': 'Выйти из-за стола',
  'table.chat_placeholder': 'Напишите сообщение',
  'table.chat_empty': 'Поздоровайтесь со всеми 👋',
  'table.music_on': 'Музыка включена',
  'table.music_off': 'Музыка выключена',
  'table.now_playing': 'Сейчас играет',
  'table.tap_to_listen': 'Нажмите, чтобы слушать',
  'table.music_error': 'Это видео нельзя воспроизвести здесь',
  'table.dj_title': 'Заказать песню для стола',
  'table.dj_hint': 'Вставьте ссылку YouTube. Её услышат все за столом.',
  'table.dj_order': 'Заказать за ❤ {price}',
  'table.dj_queue': 'В очереди: {count}',
  'table.idle_kicked': 'Вас убрали из-за стола за неактивность.',
  'table.session_replaced': 'Игра открыта на другом устройстве.',
  'table.kisses.one': '{count} поцелуй',
  'table.kisses.few': '{count} поцелуя',
  'table.kisses.many': '{count} поцелуев',
  'table.kisses.other': '{count} поцелуя',
  'table.joined': '{name} садится за стол',
  'table.left': '{name} выходит из-за стола',
  'table.gift_sent': '{from} дарит {emoji} игроку {to}',
  'table.dj_dedicated': '{name} посвящает песню {to}: {title}',
  'table.dj_for': 'для {name}',
  'table.dj_dedicate': 'Посвятить песню: {name}',
  'table.dj_video': 'Показать как клип (❤ {price})',
  'gifts.category.romance': 'Романтика',
  'gifts.category.hats': 'Шляпы и короны',
  'gifts.category.animals': 'Животные',
  'gifts.category.music': 'Музыка',
  'gifts.category.vip': 'VIP',
  'table.dj_ordered': '{name} заказал(а) песню: {title}',

  'player.send_gift': 'Подарить',
  'player.hidden_message': 'Тайное послание',
  'player.dare': 'Задание',
  'player.admire': 'Стать поклонником за ❤ {price}',
  'player.admirer': 'Поклонник: {name} (❤ {price})',
  'player.no_admirer': 'Поклонников пока нет',
  'player.block': 'Заблокировать',
  'player.unblock': 'Разблокировать',
  'player.report': 'Пожаловаться',
  'player.you': 'Это вы',
  'player.achievements.one': '{count} достижение',
  'player.achievements.few': '{count} достижения',
  'player.achievements.many': '{count} достижений',
  'player.achievements.other': '{count} достижения',

  'gifts.title': 'Подарок для {name}',
  'gifts.category.flowers': 'Цветы',
  'gifts.category.drinks': 'Напитки',
  'gifts.category.sweets': 'Сладости',
  'gifts.category.fun': 'Весёлое',
  'gifts.category.status': 'Роскошь',
  'gifts.category.pranks': 'Приколы',
  'gifts.category.seasonal': 'Сезонное',

  'ratings.title': 'Рейтинги',
  'ratings.kisses': 'Самые целуемые',
  'ratings.dj': 'Лучшие диджеи',
  'ratings.day': 'Сегодня',
  'ratings.week': 'Эта неделя',
  'ratings.month': 'Этот месяц',
  'ratings.all': 'За всё время',
  'ratings.you': 'Вы',
  'ratings.empty': 'Здесь пока никого. Будьте первым!',

  'achievements.title': 'Достижения',
  'achievements.progress': '{progress} / {threshold}',
  'achievements.reward': 'Награда: ❤ {reward}',

  'errors.VIP_REQUIRED': 'Это доступно только VIP.',
  'errors.NOT_OWNED': 'У вас ещё нет этого предмета.',
  'lobby.vip': 'VIP',
  'lobby.styling': 'Стиль',
  'vip.title': 'VIP-статус',
  'vip.active_until': 'VIP до {date}',
  'vip.inactive': 'Выделяйтесь за любым столом.',
  'vip.perk_name': 'Золотое имя и значок VIP за столом и в чате',
  'vip.perk_bottle': 'VIP-бутылка для вашего стола',
  'vip.perk_frames': 'Эксклюзивные VIP-рамки',
  'vip.perk_gifts': 'VIP-подарки и стикеры',
  'vip.plan': '{days} дней',
  'vip.buy': 'Купить за ❤ {price}',
  'vip.extend': 'Продлить за ❤ {price}',
  'vip.bought': 'Вы VIP до {date}! 👑',
  'styling.title': 'Стиль',
  'styling.none': 'Без стиля',
  'styling.none_hint': 'Оставить фото и имя без оформления',
  'styling.buy': 'Купить за ❤ {price}',
  'styling.equip': 'Надеть',
  'styling.equipped': 'Надето',
  'styling.remove': 'Снять',
  'styling.owned': 'Ваше',
  'styling.vip_only': 'Только VIP',
  'styling.reward.league_champion': 'Награда: победа в лиге за день',
  'styling.reward.kiss_master': 'Награда: получить 1000 поцелуев',
  'bottle.put': 'Поставить на стол за ❤ {price}',
  'bottle.pick': 'Выберите бутылку',
  'bottle.title': 'Сменить бутылку',
  'bottle.hint': 'Бутылка сменится для всех за этим столом.',
  'bottle.current': 'На столе',
  'bottle.changed': '{name} поставил(а) на стол бутылку «{skin}» 🍾',
  'table.change_bottle': 'Сменить бутылку',
  'bottle.classic': 'Классическая',
  'bottle.emerald': 'Изумруд',
  'bottle.amber': 'Янтарь',
  'bottle.champagne': 'Шампанское',
  'bottle.cola': 'Кола',
  'bottle.lemonade': 'Лимонад',
  'bottle.whisky': 'Виски',
  'bottle.wine': 'Красное вино',
  'bottle.sparkle': 'Искристая',
  'bottle.ice': 'Ледяная',
  'bottle.gold': 'Золотая',
  'bottle.potion': 'Любовное зелье',
  'bottle.baby': 'Детская бутылочка',
  'bottle.vip': 'VIP',
  'frame.rose_garden': 'Розовый сад',
  'frame.neon_pink': 'Розовый неон',
  'frame.neon_cyan': 'Бирюзовый неон',
  'frame.hearts': 'Сердечки',
  'frame.candy': 'Леденец',
  'frame.bow': 'Бантик',
  'frame.leaves': 'Осень',
  'frame.flame': 'Пламя',
  'frame.ice': 'Лёд',
  'frame.butterfly': 'Бабочка',
  'frame.emerald': 'Изумруд',
  'frame.ruby': 'Рубин',
  'frame.sapphire': 'Сапфир',
  'frame.devil': 'Чертёнок',
  'frame.angel': 'Ангел',
  'frame.galaxy': 'Галактика',
  'frame.rainbow': 'Радуга',
  'frame.royal': 'Королевская',
  'frame.vip_gold': 'VIP золото',
  'frame.vip_diamond': 'VIP бриллиант',
  'frame.league_champion': 'Чемпион лиги',
  'frame.kiss_master': 'Мастер поцелуев',
  'stickers.title': 'Мои стикеры',
  'stickers.pack.basic': 'Базовые',
  'stickers.pack.love': 'Любовь',
  'stickers.pack.party': 'Вечеринка',
  'stickers.pack.animals': 'Животные',
  'stickers.pack.vip': 'VIP',
  'stickers.cost': 'Каждый стикер стоит ❤ {price} и появляется над вашей аватаркой.',
  'stickers.buy': 'Открыть за ❤ {price}',
  'stickers.vip_only': 'Для VIP-игроков',
  'ratings.emotional': 'Самые эмоциональные',
  'wheel.title': 'Колесо фортуны',
  'wheel.spin': 'Крутить',
  'wheel.chances': 'Шансы: {count}',
  'wheel.free': 'Бесплатный шанс дня',
  'wheel.free_taken': 'Бесплатный шанс снова будет завтра',
  'wheel.shop': 'Магазин шансов',
  'wheel.pack': 'Шансов: {count}',
  'wheel.pack_one': '1 шанс',
  'wheel.help': 'Как это работает',
  'wheel.help_text':
    'Каждое вращение стоит один шанс. Приз выбирает сервер с шансами из таблицы ниже; выигранные шансы можно тратить снова. Бустеры используются на экране лиги.',
  'wheel.odds': 'Вероятности',
  'wheel.won': 'Ваш приз: {prize}',
  'wheel.jackpot_banner': '🎰 {name} сорвал(а) джекпот: {prize}!',
  'wheel.big_win_banner': '🎡 {name} выиграл(а) {prize} на колесе',
  'wheel.need_chance': 'Шансов нет: завтра будет бесплатный, или купите ниже.',
  'wheel.boosters': 'Мои бустеры',
  'wheel.prize.hearts_3': '❤ 3',
  'wheel.prize.hearts_5': '❤ 5',
  'wheel.prize.hearts_25': '❤ 25',
  'wheel.prize.hearts_100': '❤ 100',
  'wheel.prize.jackpot': 'Джекпот ❤ 1000',
  'wheel.prize.chance_1': '+1 шанс',
  'wheel.prize.chance_3': '+3 шанса',
  'wheel.prize.boost_x2': 'Бустер ×2',
  'wheel.prize.boost_limit': 'Бустер +10 к лимиту',
  'wheel.prize.boost_bonus': 'Бустер +5 очков',
  'booster.x2': 'Удвоение очков лиги',
  'booster.x2_desc': 'Полученные поцелуи 5 минут считаются вдвойне (кроме поцелуев-подарков).',
  'booster.limit': 'Увеличение лимита лиги',
  'booster.limit_desc': 'Дневной лимит очков за полученные поцелуи растёт на 10.',
  'booster.bonus': 'Бонусные очки лиги',
  'booster.bonus_desc': '+5 очков лиги сразу, сверх любого лимита.',
  'lobby.wheel': 'Колесо',
  'league.title': 'Лиги',
  'league.tier.wooden': 'Деревянная лига',
  'league.tier.bronze': 'Бронзовая лига',
  'league.tier.silver': 'Серебряная лига',
  'league.tier.gold': 'Золотая лига',
  'league.tier.platinum': 'Платиновая лига',
  'league.tier.diamond': 'Бриллиантовая лига',
  'league.ends_in': 'Итоги через {h} ч {m} мин',
  'league.points': '★ {points}',
  'league.kiss_limit': 'Очки за поцелуи сегодня: {used} / {cap}',
  'league.zone_up': 'Переход в высшую лигу',
  'league.zone_down': 'Понижение в лиге',
  'league.rewards': 'Награды',
  'league.chest.red': 'Красный сундук',
  'league.chest.blue': 'Синий сундук',
  'league.chest.wooden': 'Деревянный сундук',
  'league.chest.box': 'Подарочная коробка',
  'league.chest_contents': '❤ {hearts} + 🎲 {chances}',
  'league.box_contents': '🎲 {chances} за {points}+ очков',
  'league.place': '{place} место',
  'league.empty':
    'Наберите первые очки сегодня, чтобы попасть в группу: дарите подарки, заказывайте песни, восхищайтесь игроками или получайте поцелуи.',
  'league.rules': 'Правила',
  'league.rules_text':
    'Лиги — ежедневные соревнования. Очко даётся за каждое сердце, потраченное на подарки, музыку и восхищения, и за каждый полученный поцелуй (до {cap} в день). В конце дня первые {promote} в группе переходят в лигу выше, последние {demote} — ниже (в группах от {min} игроков). Тройка лидеров получает сундуки, все с {box}+ очками — подарочную коробку.',
  'league.use': 'Использовать',
  'league.x2_active': '×2 включён: {time}',
  'league.used.x2': 'Полученные поцелуи 5 минут считаются вдвойне!',
  'league.used.limit': 'Лимит поцелуев на сегодня вырос на 10.',
  'league.used.bonus': '+5 очков лиги!',
  'league.last_result': 'Прошлый итог: {place} место, {tier}',
  'league.moved_up': '⬆ Повышение',
  'league.moved_down': '⬇ Понижение',
  'league.stayed': 'Без изменений',
  'league.result_toast': 'Итоги лиги: {place} место. {chest}',
  'league.get_boosters': 'Бустеры можно выиграть на колесе фортуны',
  'lobby.league': 'Лига',
  'achievement.kisser.title': 'Целовальщик',
  'achievement.kisser.desc': 'Подарено поцелуев: {count}',
  'achievement.popular.title': 'Популярность',
  'achievement.popular.desc': 'Получено поцелуев: {count}',
  'achievement.mutual.title': 'Взаимность',
  'achievement.mutual.desc': 'Взаимных поцелуев: {count}',
  'achievement.spinner.title': 'Мастер бутылочки',
  'achievement.spinner.desc': 'Вращений бутылочки: {count}',
  'achievement.regular.title': 'Завсегдатай',
  'achievement.regular.desc': 'Сыграно раундов: {count}',
  'achievement.generous.title': 'Щедрость',
  'achievement.generous.desc': 'Отправлено подарков: {count}',
  'achievement.adored.title': 'Обожание',
  'achievement.adored.desc': 'Получено подарков: {count}',
  'achievement.dj.title': 'Диджей',
  'achievement.dj.desc': 'Заказано песен: {count}',
  'achievement.chatty.title': 'Болтун',
  'achievement.chatty.desc': 'Сообщений в чате: {count}',
  'achievement.daredevil.title': 'Смельчак',
  'achievement.daredevil.desc': 'Принято заданий: {count}',
  'achievement.streak.title': 'Верность',
  'achievement.streak.desc': 'Дней бонуса подряд: {count}',
  'achievement.emotional.title': 'Эмоциональность',
  'achievement.emotional.desc': 'Отправлено стикеров: {count}',
  'achievement.lucky.title': 'Везунчик',
  'achievement.lucky.desc': 'Вращений колеса: {count}',
  'achievement.admirer.title': 'Поклонник',
  'achievement.admirer.desc': 'Восхищений: {count}',
  'achievement.charmer.title': 'Обаяние',
  'achievement.charmer.desc': 'Вами восхитились: {count}',
  'achievement.champion.title': 'Чемпион',
  'achievement.champion.desc': 'Сундуков лиги: {count}',
  'achievement.league.title': 'Восхождение',
  'achievement.league.desc': 'Лига: {count} из 5',
  'achievement.bartender.title': 'Бармен',
  'achievement.bartender.desc': 'Смен бутылки: {count}',
  'achievement.secret.title': 'Тайный поклонник',
  'achievement.secret.desc': 'Тайных сообщений: {count}',
  'ratings.expensive': 'Самые дорогие',
  'ratings.important': 'Самые важные',
  'ratings.top': 'ТОП',
  'ratings.help.kisses': 'Полученные поцелуи, включая поцелуи-подарки.',
  'ratings.help.dj':
    'Сердца, потраченные на музыку, плюс одно за каждый подарок, полученный во время вашей песни.',
  'ratings.help.expensive': 'Цена вашего последнего восхищения или цена, за которую вы отказали поклоннику.',
  'ratings.help.important':
    'Сердца, потраченные на восхищения; вычитаются, если вам отказали или вас перебили.',
  'ratings.help.emotional': 'Сердца, потраченные на стикеры (жесты).',
  'achievements.stars': '★ {stars} / {total}',
  'achievements.filter.all': 'Все',
  'achievements.filter.done': 'Выполненные',
  'achievements.filter.locked': 'Закрытые',
  'achievements.next': 'Следующая звезда: {progress} / {goal} · ❤ {reward}',
  'achievements.complete': 'Все звёзды получены!',
  'player.turn_down': 'Отказать поклоннику',
  'player.turned_down': 'Вы отказали: {name}',
  'notify.turned_down': '{name} отказал(а) вам',
  'activity.title': 'Бонус и рейтинг',
  'activity.today': 'Сегодня',
  'activity.yesterday': 'Вчера',
  'activity.time': 'Время активности',
  'activity.time_value': '{h} ч {m} мин',
  'activity.milestone': '{hours} ч → ❤ {reward}',
  'activity.points': 'Очки активности',
  'activity.how': 'Правила очков',
  'activity.kind.message': 'Сообщение в чате',
  'activity.kind.song': 'Заказанная песня',
  'activity.kind.booster': 'Использованный бустер',
  'activity.kind.gift': 'Отправленный подарок',
  'activity.kind.round': 'Сыгранный раунд',
  'activity.kind.sticker': 'Отправленный стикер',
  'activity.kind.wheel': 'Вращение колеса',
  'activity.rules':
    'Время засчитывается, пока вы активны за столом (действие хотя бы раз в {gap} минут). Очки дают до {cap} сообщений в день. Дневной топ закрывается в полночь; первые {places} места получают сердца. Спам не засчитывается.',
  'activity.top': 'Дневной топ-{size}',
  'activity.prize': '❤ {hearts}',
  'activity.ends_in': 'Закроется через {h} ч {m} мин',
  'activity.empty': 'Сегодня пока нет активности.',
  'activity.reward_toast': 'Награда за активность: ❤ {hearts}',
  'activity.top_toast': 'Дневной топ активности: {place} место, ❤ {hearts}',
  'lobby.bonus': 'Бонус',
  'friends.title': 'Список друзей',
  'friends.add': 'Добавить в друзья',
  'friends.requested': 'Заявка отправлена',
  'friends.accept': 'Принять',
  'friends.decline': 'Отклонить',
  'friends.remove': 'Удалить из друзей',
  'friends.friends': 'Друзья',
  'friends.incoming': 'Заявки в друзья',
  'friends.outgoing': 'Отправленные заявки',
  'friends.empty': 'Друзей пока нет.',
  'friends.online': 'в сети',
  'friends.at_table': 'за столом',
  'friends.join': 'Присоединиться',
  'friends.count': 'Друзья: {count}',
  'friends.hidden': 'Друзья скрыты',
  'friends.privacy': 'Кто видит моих друзей',
  'friends.privacy.everyone': 'Все',
  'friends.privacy.me': 'Только я',
  'notify.friend_request': '{name} хочет добавить вас в друзья',
  'notify.friend_accepted': '{name} принял(а) вашу заявку в друзья',
  'lobby.friends': 'Друзья',
  'settings.gender': 'Пол',
  'settings.gender_hint': 'Менять можно раз в {days} дней и не за столом.',
  'settings.gender_next': 'Следующая смена: {date}',
  'errors.GENDER_COOLDOWN': 'Вы недавно меняли пол. Попробуйте позже.',
  'errors.TOO_MANY_FRIENDS': 'Список друзей заполнен.',
  'errors.TRANSLATION_UNAVAILABLE': 'Перевод сейчас недоступен.',
  'table.show_translation': 'Показать перевод',
  'table.hide_translation': 'Скрыть перевод',
  'table.translating': 'Переводим…',
  'player.league': '{league}',
  'player.send_gift_title': 'Подарок для {name}',
  'settings.photo_change': 'Сменить фото',
  'settings.photo_reset': 'Вернуть фото из Telegram',
  'settings.photo_hint':
    'Пока вы не загрузили своё фото, показывается фото из Telegram. Неприемлемые фото удаляются, за них можно получить бан.',
  'settings.photo_preview': 'Новое фото',
  'settings.photo_saved': 'Фото обновлено',
  'settings.name_reset': 'Вернуть имя из Telegram',
  'errors.UNSUPPORTED_IMAGE': 'Эту картинку нельзя использовать. Попробуйте другое фото.',
  'lobby.domino': 'Домино',
  'domino.title': 'Домино',
  'domino.rules': 'Классическое домино с базаром · кто первым наберёт {target}, забирает банк',
  'domino.rake': 'Комиссия {percent}%',
  'domino.quick': 'Быстрая игра',
  'domino.free': 'Бесплатно',
  'domino.create': 'Открыть стол',
  'domino.seats': 'Игроков',
  'domino.stake_label': 'Ставка',
  'domino.open_rooms': 'Столы ждут игроков',
  'domino.no_rooms': 'Открытых столов нет: откройте свой или начните быструю игру.',
  'domino.join': 'Сесть',
  'domino.back_to_game': 'Вы за столом: вернуться к игре',
  'domino.waiting': 'Ждём игроков… {n}/{seats}',
  'domino.leave': 'Выйти',
  'domino.leave_confirm': 'Выйти из игры? Это поражение, ставка остаётся в банке.',
  'domino.leave_refund': 'Выйти (ставка вернётся)',
  'domino.pot': 'Банк ❤ {pot}',
  'domino.round': 'Раунд {round} · до {target}',
  'domino.your_turn': 'Ваш ход',
  'domino.turn_of': 'Ходит {name}',
  'domino.draw': 'Взять ({n})',
  'domino.pass': 'Пас',
  'domino.choose_end': 'К какому концу?',
  'domino.left': '◀ Слева',
  'domino.right': 'Справа ▶',
  'domino.boneyard': 'Базар {n}',
  'domino.drew': '{name} взял(а) {n}',
  'domino.passed': '{name}: пас',
  'domino.auto': '{name}: время вышло',
  'domino.round_won': '{name} выигрывает раунд: +{points}',
  'domino.round_blocked': 'Рыба! Меньше всего у {name}: +{points}',
  'domino.round_tie': 'Рыба с ничьей: очков нет',
  'domino.next_round': 'Следующий раунд через {s} с',
  'domino.game_won': '{name} выигрывает партию!',
  'domino.you_won': 'Вы выиграли ❤ {payout}!',
  'domino.out': 'выбыл',
  'domino.to_lobby': 'К столам',
  'domino.cancelled': 'Стол закрыт, ставки возвращены.',
  'domino.started': 'Ваша партия в домино началась!',
  'domino.points': '{score} очк.',
  'domino.empty_seat': 'Свободно',
  'domino.first_move': 'Начните с подсвеченного дубля',
  'errors.ILLEGAL_MOVE': 'Эта костяшка сюда не подходит.',
  'errors.DOMINO_DISABLED': 'Домино недоступно.',
  'errors.ALREADY_IN_GAME': 'Вы уже за столом домино.',
  'lobby.live': 'Эфиры',
  'live.title': 'Эфиры',
  'live.go_live': 'Начать эфир',
  'live.vip_only': 'Эфиры ведут VIP-игроки, смотреть может каждый.',
  'live.connect_failed':
    'Не удалось подключиться к видео эфира. Проверьте интернет (или попробуйте мобильный интернет) и откройте снова.',
  'live.no_webrtc':
    'Это приложение Telegram не воспроизводит видео эфира. Откройте игру в Telegram на телефоне или на web.telegram.org.',
  'live.empty': 'Сейчас никто не в эфире.',
  'live.viewers': '{n} смотрят',
  'live.start_title': 'Ваш эфир',
  'live.title_placeholder': 'О чём ваш эфир?',
  'live.rules':
    'Мне есть 18. Я не показываю наготу и несовершеннолетних и не делюсь контактами. Нарушение правил останавливает эфир и может привести к бану.',
  'live.start': 'Начать трансляцию',
  'live.camera_needed': 'Разрешите камеру и микрофон, чтобы выйти в эфир',
  'live.end': 'Завершить эфир',
  'live.end_confirm': 'Завершить эфир сейчас?',
  'live.ended': 'Эфир завершён',
  'live.ended_reports': 'Эфир остановлен после жалоб',
  'live.ended_admin': 'Администратор остановил эфир',
  'live.ended_lost': 'Связь со стримером потеряна',
  'live.back': 'К эфирам',
  'live.chat_placeholder': 'Напишите что-нибудь приятное…',
  'live.sent_gift': '{name} дарит {emoji}',
  'live.report': 'Пожаловаться',
  'live.reported': 'Спасибо, администраторы посмотрят.',
  'live.tap_sound': '🔊 Нажмите для звука',
  'live.connecting': 'Подключение…',
  'live.gift_title': 'Подарок для {name}',
  'live.you_are_live': 'Вы в эфире',
  'live.waiting_video': 'Ждём видео…',
  'live.like': 'Лайк',
  'live.gift': 'Подарок',
  'live.camera': 'Камера',
  'live.admin_tab': 'Эфиры',
  'live.admin_end': 'Остановить',
  'live.admin_reports': 'жалоб: {n}',
  'live.admin_none': 'Эфиров ещё не было.',
  'errors.LIVE_DISABLED': 'Эфиры недоступны.',
  'errors.ALREADY_LIVE': 'Вы уже в эфире.',
  'errors.STREAM_ENDED': 'Эфир завершён.',

  'settings.title': 'Настройки',
  'settings.sound': 'Звуки',
  'settings.music': 'Музыка',
  'settings.notifications': 'Уведомлять о тайных посланиях в боте',
  'settings.language': 'Язык',
  'settings.name': 'Имя за столом',
  'settings.birth_year': 'Год рождения',
  'settings.blocked': 'Заблокированные игроки',
  'settings.support': 'Поддержка',
  'settings.saved': 'Сохранено',

  'invite.title': 'Пригласить друзей',
  'invite.text': 'Вы и ваш друг получите ❤ {bonus}, когда он сыграет первый раунд.',
  'invite.share': 'Поделиться ссылкой',
  'invite.copy': 'Скопировать ссылку',
  'invite.copied': 'Ссылка скопирована',
  'invite.stats': 'Приглашено: {invited} · Награждено: {rewarded}',
  'invite.share_text': 'Сыграем в «Бутылочку»! 🍾💋',

  'notify.admired': '{name} стал(а) вашим поклонником за ❤ {price}',
  'notify.outbid': '{name} перебил(а) вашу ставку за {target}',
  'notify.gift': '{name} дарит вам {emoji}',
  'notify.achievement': 'Достижение: {title} ★{level} (+❤ {reward})',
  'notify.referral': '+❤ {bonus}: {name} пришёл(а) в игру по вашему приглашению!',
  'notify.wallet': '+❤ {amount}',
  'notify.gm': '💰 +{amount} GM',
  'notify.transfer_gm': '{name} отправил(а) вам {amount} GM',
  'notify.transfer_hearts': '{name} отправил(а) вам ❤ {amount}',

  'admin.live_reported': '🔴 Эфир {name} остановлен после {reports} жалоб.',
  'admin.auto_mute': '⚠️ Автомьют: игрок {userId} получил {reports} жалоб за 24 часа.',
  'admin.broadcast_done': '📣 Рассылка завершена: отправлено {sent}, ошибок {failed}.',

  'bot.welcome':
    'Привет! Готовьтесь к самой весёлой «Бутылочке».\n\n👀 Смотрите, кто рядом, и начинайте общение\n🎁 Обменивайтесь сюрпризами и шуточными заданиями\n💌 Отправляйте тайные послания особенному человеку\n🎲 Играйте вместе за одним столом\n🎶 Слушайте музыку вместе со всеми\n\n🎮 Нажмите ИГРАТЬ — и вперёд!',
  'bot.play_button': '🎮 ИГРАТЬ',
  'bot.menu_button': 'ИГРАТЬ',
  'bot.help': 'В «Бутылочку» играют в мини-приложении: нажмите 🎮 PLAY.',
  'bot.rate_limited': 'Слишком много запросов. Помедленнее.',
  'bot.banned': 'Ваш аккаунт заблокирован.',
  'bot.gm_credited': '💰 На ваш счёт зачислено +{amount} GM. Баланс: {gm} GM',
  'bot.gm_debited': '💰 Администратор списал с вашего счёта {amount} GM. Баланс: {gm} GM',
  'bot.short_description': 'Крутите бутылочку, целуйтесь, дарите подарки и ставьте музыку 💋',
  'bot.description':
    'Классическая «Бутылочка» в Telegram: столы на 12 человек, поцелуи, подарки, лиги, Колесо фортуны и музыка. 18+.',
  'bar.heart_shop': 'Магазин сердец',
  'bar.wheel': 'Колесо фортуны',
  'bar.league': 'Лига',
  'bar.misc': 'Разное',
  'bar.settings': 'Настройки',
  'bar.exit': 'Выход',
  'bar.table': 'Стол',
  'bar.change_table': 'Сменить стол',
  'menu.achievements': 'Достижения',
  'menu.ratings': 'Рейтинги',
  'menu.bottle': 'Бутылочка',
  'menu.styling': 'Оформление',
  'menu.boosters': 'Бустеры',
  'table.spin_the_bottle': 'Крути бутылочку!',
  'table.spins_the_bottle': 'Крутит бутылочку',
  'table.order_song': 'Заказать песню за ❤ {price}',
  'table.order_video': 'Заказать клип за ❤ {price}',
  'table.video_size': 'Размер видео',
  'table.play_here': 'Играть здесь',
  'gifts.send_to': 'Подарок для',
  'player.profile': 'Профиль',
  'player.admire_for': 'Восхищаться за',
  'player.reported': 'Спасибо, мы проверим.',
  'report.SPAM': 'Спам',
  'report.ABUSE': 'Оскорбления',
  'report.SEXUAL_CONTENT': 'Сексуальный контент',
  'report.UNDERAGE': 'Младше 18 лет',
  'report.OTHER': 'Другое',
  'shop.title': 'Купить сердца',
  'shop.details': 'Подробнее',
  'shop.vip_status': 'СТАТУС',
  'shop.for_friend_1': 'Получи',
  'shop.for_friend_2': 'за друга',
  'shop.bonus': 'БОНУС {percent}%',
  'shop.best_offer': 'Лучшее предложение',
  'shop.best_pick': 'Лучший выбор',
  'shop.send': 'Отправить',
  'shop.need_gm': 'Нужно {gm} GM. Попросите администратора пополнить баланс GM.',
  'shop.bought': '+❤ {hearts}',
  'shop.send_gm_title': 'Отправить другу GM {amount}',
  'shop.send_hearts_title': 'Отправить другу ❤ {amount}',
  'shop.send_left': 'Осталось отправок сегодня: {count}',
  'shop.send_no_friends': 'Сначала добавьте друзей: нажмите на игрока за столом, затем зелёный +.',
  'shop.sent_gm': '{amount} GM отправлено: {name}',
  'shop.sent_hearts': '❤ {amount} отправлено: {name}',
  'vip.perks': 'Стань VIP: дари уникальные подарки, используй эмодзи и выделяйся особым цветом имени!',
  'wheel.rules': 'Нажмите «Крутить» — запустите Колесо фортуны и получите награду!',
  'wheel.chances_label': 'Шансы:',
  'wheel.price': 'Цена:',
  'wheel.winner': 'Победитель',
  'wheel.jackpot_text': 'сорвал(а) джекпот и получил(а) ❤ 1000',
  'wheel.big_win_text': 'выиграл(а) {prize}',
  'league.hint': 'Используйте бустеры, чтобы подняться выше',
  'league.boosters': 'Бустеры',
  'league.zone_up_hint': 'переход в высшую лигу',
  'league.final_in': 'Итоги через: {hours} ч.',
  'league.until_limit': 'До лимита:',
  'league.activate': 'Активировать',
  'league.rules_1':
    'Лиги — это ежедневные соревнования, в которых можно выиграть сердца и уникальные подарки.',
  'league.rules_2':
    'Очки дают за подарки, полученные поцелуи, музыку и восхищение. Одно очко за каждое потраченное сердце: чем больше подарков, тем больше очков.',
  'league.rules_3':
    'В конце дня первые {promote} игроков переходят в следующую лигу и получают сундуки; последние {demote} опускаются ниже.',
  'league.rules_4':
    'Полученные поцелуи дают не больше {cap} очков в день. Бустеры из Колеса фортуны помогают: двойные очки, выше лимит и бонусные очки.',
  'achievements.mine': 'Мои достижения',
  'achievements.count': '{stars}/{total}',
  'achievements.show_first': 'Сначала:',
  'achievements.completed': 'выполненные',
  'achievements.locked': 'закрытые',
  'achievements.detail': 'Достижение',
  'achievements.meet': 'Выполните условия, чтобы получить:',
  'ratings.help_title': 'Об этом рейтинге',
  'ratings.period': 'Период',
  'ratings.top_n': 'Топ-{n} лучших игроков',
  'ratings.period_all': 'за всё время',
  'ratings.period_month': 'за месяц',
  'ratings.period_week': 'за неделю',
  'ratings.period_day': 'сегодня',
  'styling.apply': 'Применить',
  'styling.owned_hint': 'Эта рамка уже ваша.',
  'styling.buy_hint': 'Купите рамку за ❤ {price} и наденьте её.',
  'styling.locked': 'Эта рамка — награда.',
  'settings.sounds': 'Звуки',
  'settings.invite': 'Пригласить друзей',
  'settings.friends': 'Мои друзья',
  'settings.contact': 'Связаться с нами',
  'friends.who_sees': 'Кто видит мою дружбу?',
  'friends.visibility_everyone': 'Все',
  'friends.visibility_me': 'Только я',
  'friends.sent': 'Отправлено заявок: {count}',
  'activity.hours': '{hours} ч',
  'activity.more': 'ЕЩЁ',
  'activity.less': 'СВЕРНУТЬ',
  'activity.h': 'ч',
  'activity.m': 'м',
  'activity.pts': '{points} оч.',
  'activity.my_place': 'Ваше место: #{rank} · {points} оч.',
  'portal.logout': 'Выйти',
  'portal.services': 'Сервисы',
  'portal.invited': 'Приглашённые',
  'portal.invited_empty': 'По вашей ссылке пока никто не пришёл.',
  'portal.no_status': 'Статуса пока нет',
  'portal.status_title': 'Ваш статус',
  'portal.status_placeholder': 'Напишите что-нибудь о себе…',
  'portal.start': 'Играть',
  'portal.watch': 'Смотреть',
  'portal.license': 'Лицензия',
  'portal.license_title': '{name} v2',
  'portal.license_text': '© {year}. Все права защищены. Поцелуи и подарки виртуальные и только для веселья.',
  'services.store': 'Магазин',
  'services.balance': 'Баланс:',
  'services.username': 'Имя пользователя',
  'services.game_name': 'Имя в игре',
  'services.profile': 'Профиль',
  'services.password': 'Сменить пароль',
  'services.password_text': 'Смените пароль аккаунта.',
  'services.gender': 'Сменить пол',
  'services.gender_text': 'Измените информацию о поле.',
  'services.name': 'Сменить имя в игре',
  'services.name_text': 'Измените имя, которое видно в играх.',
  'services.photo': 'Сменить фото профиля',
  'services.photo_text': 'Настройте фото профиля.',
  'services.back': 'НАЗАД',
  'services.password_current': 'Текущий пароль',
  'services.password_new': 'Новый пароль (не меньше 6 символов)',
  'services.password_repeat': 'Повторите новый пароль',
  'services.password_hint': 'С паролем можно войти на сайт по вашему ID.',
  'services.password_mismatch': 'Пароли не совпадают.',
  'services.password_saved': 'Пароль сохранён.',
  'services.gender_later': 'Снова изменить можно после {date}.',
  'services.name_telegram': 'Взять имя из Telegram ({name})',
  'services.photo_pick': 'Выбрать фото',
  'services.photo_telegram': 'Взять фото из Telegram',
  'login.title': 'Вход',
  'login.login': 'ID или @username',
  'login.password': 'Пароль',
  'login.submit': 'Войти',
  'login.hint': 'Пароль задаётся в игре: выход → Сервисы → Сменить пароль.',
  'login.open_bot': 'Открыть игру в Telegram',
  'login.developer': 'Вход разработчика',
  'watch.back': 'Назад',
  'watch.live_caps': 'ЭФИР',
  'watch.live_tab': 'Эфир ({count})',
  'watch.domino_tab': 'Домино ({count})',
  'watch.no_streams': 'Активных эфиров нет.',
  'watch.first_stream': 'Начать первый эфир',
  'live.no_other_camera': 'Другой камеры нет.',
  'courting.title': 'Ухаживание',
  'courting.text': '{name} восхищается вами за',
  'courting.ok': 'Хорошо',

  // Daily horoscope (menu ≡ → Horoscope).
  'menu.horoscope': 'Гороскоп',
  'horoscope.title': 'Гороскоп на сегодня',
  'horoscope.pick': 'Выберите свой знак',
  'horoscope.today': 'Сегодня, {date}',
  'horoscope.love_title': 'Любовь',
  'horoscope.lucky_number': 'Счастливое число',
  'horoscope.lucky_color': 'Счастливый цвет',
  'horoscope.change': 'Сменить знак',
  'portal.credits': '3D-картинки: Microsoft Fluent Emoji (MIT). Знаки зодиака: Freepik.',
  'horoscope.sign.aries': 'Овен',
  'horoscope.sign.taurus': 'Телец',
  'horoscope.sign.gemini': 'Близнецы',
  'horoscope.sign.cancer': 'Рак',
  'horoscope.sign.leo': 'Лев',
  'horoscope.sign.virgo': 'Дева',
  'horoscope.sign.libra': 'Весы',
  'horoscope.sign.scorpio': 'Скорпион',
  'horoscope.sign.sagittarius': 'Стрелец',
  'horoscope.sign.capricorn': 'Козерог',
  'horoscope.sign.aquarius': 'Водолей',
  'horoscope.sign.pisces': 'Рыбы',
  'horoscope.general.0': 'Хороший день для новых знакомств. Поздоровайтесь первым и посмотрите, что будет.',
  'horoscope.general.1': 'Сегодня у вас много энергии. Крутите бутылочку не один раз!',
  'horoscope.general.2': 'Кто-то за столом думает о вас больше, чем вы думаете.',
  'horoscope.general.3': 'Сегодня проще значит лучше: шутка откроет больше дверей, чем серьёзный разговор.',
  'horoscope.general.4': 'Сегодня маленький подарок может произвести большое впечатление.',
  'horoscope.general.5': 'Доверяйте первому впечатлению. Сегодня оно вас не подведёт.',
  'horoscope.general.6': 'Спокойный день. Наслаждайтесь музыкой и компанией.',
  'horoscope.general.7': 'Сегодня удача на стороне смелых. Сделайте первый шаг.',
  'horoscope.general.8': 'Старый друг может сегодня удивить вас. Не пропустите сообщения.',
  'horoscope.general.9': 'Сегодня терпение окупится. К вечеру получите то, чего хотите.',
  'horoscope.love.0': 'Сегодняшний поцелуй может стать началом чего-то особенного.',
  'horoscope.love.1': 'Ваша улыбка сегодня — лучший подарок.',
  'horoscope.love.2': 'Кто-то тайно вами восхищается. Посмотрите вокруг стола.',
  'horoscope.love.3': 'Будьте честны в своих чувствах. Это оценят.',
  'horoscope.love.4': 'Сегодня очень вероятен взаимный поцелуй.',
  'horoscope.love.5': 'Не спешите: лучшее приходит со временем.',
  'horoscope.color.0': 'Красный',
  'horoscope.color.1': 'Розовый',
  'horoscope.color.2': 'Золотой',
  'horoscope.color.3': 'Синий',
  'horoscope.color.4': 'Зелёный',
  'horoscope.color.5': 'Фиолетовый',
};
